/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../helpers";
import { Logout } from "../../../../common/api/logout";
import { menuConfig } from "./menuConfig";
import { MenuItem } from "./MenuItem";
import { useSelector } from "react-redux";
import { hasRouteAccess } from "../../../../utils/permissions";

export function AsideMenuList({ layoutProps, selectedSite, siteEntities }) {
  const location = useLocation();
  const user = useSelector((state) => state.user);

  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
      "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };

  const selectedTabSite = siteEntities.find(
    (item) => item.value === selectedSite
  );

  // Check if any Site submenu item is visible
  const siteMenuConfig = menuConfig.find(item => item.id === 'site');
  const hasVisibleSiteChildren = () => {
    // ADMIN role always sees the site menu
    if (user?.role === "ADMIN") {
      return true;
    }

    // For STAFF and MO, check if any child has permission
    return siteMenuConfig?.submenu?.some((subItem) => {
      if (subItem.isPublic) return true;
      if (subItem.path && hasRouteAccess(user, subItem.path)) return true;
      return false;
    }) || false;
  };

  // Generate active classes for Site submenu dynamically
  const siteActiveClasses = siteMenuConfig?.submenu
    ?.map(subItem => getMenuItemActive(subItem.path || "", false))
    .join("") || "";

  return (
    <>
      {/* begin::Menu Nav */}
      <ul
        className={`menu-nav ${layoutProps.ulClasses}`}
        style={{ paddingTop: 0 }}
      >
        {/* SITE NAME LIST */}
        {hasVisibleSiteChildren() && (
          <li
            className={`menu-item menu-item-submenu ${siteActiveClasses}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="#">
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Box2.svg")} />
              </span>
              <span className="menu-text">
                Site {selectedTabSite ? `(${selectedTabSite?.label})` : ""}
              </span>
              <i className="menu-arrow" />
            </NavLink>

            <div className="menu-submenu ">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                {/* Render all site submenu items from config */}
                {menuConfig.find(item => item.id === 'site')?.submenu?.map((subItem) => (
                  <MenuItem
                    key={subItem.id}
                    item={subItem}
                    selectedSite={selectedSite}
                    getMenuItemActive={getMenuItemActive}
                  />
                ))}
              </ul>
            </div>
          </li>
        )}

        {/* Render all other menu items from config (excluding site and welcome) */}
        {menuConfig
          .filter(item => item.id !== 'site' && item.id !== 'welcome')
          .map((item) => (
            <MenuItem
              key={item.id}
              item={item}
              selectedSite={selectedSite}
              getMenuItemActive={getMenuItemActive}
            />
          ))}

        {/* logout */}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("#", false)}`}
          aria-haspopup="true"
          onClick={Logout}
        >
          <NavLink className="menu-link" to="/auth/login">
            {/* <span className="svg-icon menu-icon"> */}
            <span className="menu-icon">
              {/* <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Box2.svg")} /> */}
              <i className="flaticon2-logout"></i>
            </span>
            <span className="menu-text">Logout</span>
          </NavLink>
        </li>

        {/*end::1 Level*/}
      </ul>
      {/* end::Menu Nav */}
    </>
  );
}
